<template>
  <div :class="['wrapper', classes]">
    <header class="main-header">
	<span class="logo-mini text-center">
		<a href="/">
			<img src="/static/img/logo_sima_100.png" alt="Logo" class="img-responsive center-block logo">
			<span class="brand"> SIMA</span>
		</a>
	</span>
      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Sidebar toggle button-->
        <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
          <span></span>
        	<span></span>
        <span></span>
        </a>
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <!-- User Account Menu -->
            <li class="dropdown user user-menu">
              <a href="javascript:;" @click="logout()" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fas fa-sign-out-alt"></i>
                <span>Salir</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar :display-name="demo.displayName" :picture-url="demo.avatar" />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          {{$route.name.toUpperCase() }}
        </h1>
      </section>

      <router-view></router-view>
    </div>
    <!-- /.content-wrapper -->

    <!-- Main Footer -->
    <footer class="main-footer">
      <strong>Copyright &copy; {{year}} - v1.0.3</strong>
    </footer>
  </div>
  <!-- ./wrapper -->
</template>
<toast-container></toast-container>
<script>
/* eslint-disable */
import faker from 'faker'
import { mapState } from 'vuex'
import config from '../config'
import Sidebar from './Sidebar'
import 'hideseek'
import axios from "axios";

export default {
    name: 'Dash',
    components: {
    	Sidebar
    },
    data: function () {
    return {
        	// section: 'Dash',
          	localUserString: JSON.parse(window.localStorage.getItem('user')),
            year: new Date().getFullYear(),
            classes: {
                fixed_layout: config.fixedLayout,
                hide_logo: config.hideLogoOnMobile
            },
            error: '',
            onlineState: navigator.onLine,
            token: window.localStorage.getItem('token')
    	}
    },
    computed: {
    	...mapState([
      		'userInfo'
   		]),
    demo () {
            return {
              displayName: this.localUserString.username
            }
    	}
    },
	created () {
    }, 
    methods: {
        changeloading () {
          this.$store.commit('TOGGLE_SEARCHING')
        },
        logout () {
                this.$store.commit('SET_USER', null)
                this.$store.commit('SET_TOKEN', null)
            
                if (window.localStorage) {
                  window.localStorage.setItem('user', null)
                  window.localStorage.setItem('token', null)
                }
            
                this.$router.push('/login')
        }   	
    }
}
window.addEventListener("beforeunload", confirm);
function confirm(e) {
  var confirmationMessage = "Se perder�n los datos no sincronizados. �Desea continuar?";     
  e.returnValue = confirmationMessage;           
  return confirmationMessage;       
} 

</script>

<style>
.wrapper.fixed_layout .main-header {
	position: fixed;
	width: 100%;
}

.wrapper.fixed_layout .content-wrapper {
	padding-top: 50px;
	min-height: 850px;
}

.content-wrapper {
	min-height: 850px !important;
}

.wrapper.fixed_layout .main-sidebar {
	position: fixed;
	height: 100vh;
}

.brand {
	color: #fff;
	float: left;
	font-size: 20px;
	margin-top: 11px;
}

.skin-red .main-header .logo {
	width: 50px;
}
.sidebar-collapse .main-header .navbar .sidebar-toggle{
    margin-left: -40px;
}

@media ( max-width : 767px) {
	.wrapper.hide_logo .main-header .logo {
		display: none;
	}
}

.logo {
	max-width: 50px;
}

.logo-mini, .logo-lg {
	text-align: center;
}

.logo-mini img, .logo-lg img {
	padding: 0.4em !important;
}

.logo-lg img {
	display: -webkit-inline-box;
	width: 25%;
}

.user-panel {
	height: 4em;
}

hr.visible-xs-block {
	width: 100%;
	background-color: rgba(0, 0, 0, 0.17);
	height: 1px;
	border-color: transparent;
}

.sidebar-toggle span {
	display: block;
	width: 20px;
	height: 3px;
	margin-bottom: 4px;
	position: relative;
	background: #fff;
	border-radius: 3px;
	z-index: 1;
	transform-origin: 4px 0px;
	transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0),
		background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0), opacity 0.55s ease;
}

.sidebar-toggle span:first-child {
	transform-origin: 0% 0%;
}

.sidebar-toggle span:nth-last-child(2) {
	transform-origin: 0% 100%;
}

.main-header .sidebar-toggle:before {
	content: "";
}
</style>



// WEBPACK FOOTER //
// Template.vue?25e1d2ae